<script setup lang="ts">

    const props = defineProps({
        inputName: {
            type: String,
            default: 'text',
        },
        label: {
            type: String,
            default: 'text',
        },
        class: {
            type: String,
            required: false
        },
    });

    const { value, setValue, errorMessage } = useField(() => props.inputName);

    const updateValue = (event: Event) => {
        const isChecked = (event.target as HTMLInputElement).checked;
        setValue(isChecked); // Set the value directly
    };
</script>

<template>
    <div class="w-full flex justify-center max-w-[70rem] mx-auto max-md:flex-wrap">
        <a-checkbox
            :class="[ 
                { 'is-invalid' : errorMessage }, 
                'checkbox leading-[1.5] gap-[1.5rem]',
                props.class 
            ]"
            :id="props.inputName"
            :name="props.inputName"
            :checked="Boolean(value)"
            @change="updateValue"
        >
        </a-checkbox>
        <label :for="props.inputName" class="text-[1.4rem] leading-[1.5] mr-[2rem]">{{ props.label }}</label>
        <div class="flex gap-[.8rem]">
        <NuxtLink to="/terms" target="_blank"
            class="text-[blueLink] font-bold underline text-[1.4rem] leading-[1.5]">Terms
            of Service</NuxtLink>
        <span class="text-[1.4rem] leading-[1.5]">&</span>
        <NuxtLink to="/privacy" target="_blank"
            class="text-[blueLink] font-bold underline text-[1.4rem] leading-[1.5]">Privacy
            Policy</NuxtLink>
    </div>
    </div>
    <span v-if="errorMessage" class="text-[redError] text-[1.4rem] leading-[1.5] mt-[.4rem] text-center block w-fit mx-auto">{{ errorMessage }}</span>
    
    
</template>
